export enum PresentationStatus {
  CONNECTING = "CONNECTING",
  ONLINE = "ONLINE",
  NOT_STARTED = "NOT_STARTED",
  CLOSED = "CLOSED",
  // The link is dead — the host has been inactive past the extension's resume
  // window, so its extension rotated to a new link and can never return here.
  // Derived from the backend's additive `expired` flag, not a raw server status.
  EXPIRED = "EXPIRED",
  // The host is on the free plan and its copresenter seats are all taken, so
  // this joiner was turned away. Like EXPIRED it's a dead end, not a wait —
  // derived from the backend's additive `roomFull` flag.
  ROOM_FULL = "ROOM_FULL",
  // The host removed this copresenter from the room. Client-only, set from the
  // REMOVE_PRESENTER frame (or the backend's "removed" close code). It stops the
  // auto-reconnect — which would otherwise put them straight back in — but it
  // is not a ban: opening the same link again rejoins.
  REMOVED = "REMOVED",
}
